import { IRequestImmediate, IRequestImmediateRaw } from '../types'

export class RequestImmediatePixMapper {
  static toPersistence(data: IRequestImmediate): IRequestImmediateRaw {
    return {
      tipoProfissional: data.professional,
      idTriagem: data.screeningId,
      pagamento: {
        idTransacao: data.payment.transactionId,
        metodo: data.payment.method,
        sintomas: data.payment.symptoms,
        sintomasEvidentes: data.payment.evidentSymptoms,
        tipoProfissional: data.payment.professionalType,
      },
    }
  }
}
